import "core-js/modules/es.array.reverse.js";
var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.regexp.exec.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, runInAction, makeObservable } from "mobx";
import containsAny from "../../../Core/containsAny";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import isReadOnlyArray from "../../../Core/isReadOnlyArray";
import replaceUnderscores from "../../../Core/replaceUnderscores";
import runLater from "../../../Core/runLater";
import TerriaError from "../../../Core/TerriaError";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GetCapabilitiesMixin from "../../../ModelMixins/GetCapabilitiesMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import WebMapServiceCatalogGroupTraits from "../../../Traits/TraitsClasses/WebMapServiceCatalogGroupTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import updateModelFromJson from "../../Definition/updateModelFromJson";
import CatalogGroup from "../CatalogGroup";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import WebMapServiceCapabilities from "./WebMapServiceCapabilities";
import WebMapServiceCatalogItem from "./WebMapServiceCatalogItem";
let GetCapabilitiesStratum = (_class = class GetCapabilitiesStratum extends LoadableStratum(WebMapServiceCatalogGroupTraits) {
  static async load(catalogItem) {
    if (catalogItem.getCapabilitiesUrl === undefined) {
      throw new TerriaError({
        title: i18next.t("models.webMapServiceCatalogGroup.missingUrlTitle"),
        message: i18next.t("models.webMapServiceCatalogGroup.missingUrlMessage")
      });
    }
    const capabilities = await WebMapServiceCapabilities.fromUrl(proxyCatalogItemUrl(catalogItem, catalogItem.getCapabilitiesUrl, catalogItem.getCapabilitiesCacheDuration));
    return new GetCapabilitiesStratum(catalogItem, capabilities);
  }
  constructor(catalogGroup, capabilities) {
    super();
    this.catalogGroup = catalogGroup;
    this.capabilities = capabilities;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new GetCapabilitiesStratum(model, this.capabilities);
  }
  get name() {
    if (this.capabilities && this.capabilities.Service && this.capabilities.Service.Title) {
      return replaceUnderscores(this.capabilities.Service.Title);
    }
  }
  get info() {
    const result = [];
    const service = this.capabilities && this.capabilities.Service;
    if (service) {
      // Show the service abstract if there is one and if it isn't the Geoserver default "A compliant implementation..."
      if (service && service.Abstract && !containsAny(service.Abstract, WebMapServiceCatalogItem.abstractsToIgnore)) {
        result.push(createStratumInstance(InfoSectionTraits, {
          name: i18next.t("models.webMapServiceCatalogGroup.abstract"),
          content: this.capabilities.Service.Abstract
        }));
      }

      // Show the Access Constraints if it isn't "none" (because that's the default, and usually a lie).
      if (service && service.AccessConstraints && !/^none$/i.test(service.AccessConstraints)) {
        result.push(createStratumInstance(InfoSectionTraits, {
          name: i18next.t("models.webMapServiceCatalogGroup.accessConstraints"),
          content: this.capabilities.Service.AccessConstraints
        }));
      }

      // Show the Fees if it isn't "none".
      if (service && service.Fees && !/^none$/i.test(service.Fees)) {
        result.push(createStratumInstance(InfoSectionTraits, {
          name: i18next.t("models.webMapServiceCatalogGroup.fees"),
          content: this.capabilities.Service.Fees
        }));
      }
    }
    return result;
  }
  get members() {
    return filterOutUndefined(this.topLevelLayers.map(layer => this.getLayerId(layer)));
  }
  get topLevelLayers() {
    if (this.catalogGroup.flatten) {
      return this.capabilities.allLayers;
    } else {
      let rootLayers = this.capabilities.rootLayers;
      while (rootLayers && rootLayers.length === 1 && rootLayers[0].Name === undefined) {
        const subLayer = rootLayers[0].Layer;
        if (subLayer && isReadOnlyArray(subLayer)) {
          rootLayers = subLayer;
        } else if (subLayer) {
          rootLayers = [subLayer];
        } else {
          break;
        }
      }
      return rootLayers;
    }
  }
  createMembersFromLayers() {
    this.topLevelLayers.forEach(layer => this.createMemberFromLayer(layer));
  }
  createMemberFromLayer(layer, parentLayerId) {
    var _this$catalogGroup$pe;
    const layerId = this.getLayerId(layer, parentLayerId);
    if (!layerId) {
      return;
    }

    // If has nested layers -> create model for CatalogGroup
    if (layer.Layer) {
      // Create nested layers
      let members;
      if (Array.isArray(layer.Layer)) {
        members = layer.Layer;
      } else {
        members = [layer.Layer];
      }
      members.forEach(member => this.createMemberFromLayer(member, layerId));

      // Create group
      const existingModel = this.catalogGroup.terria.getModelById(CatalogGroup, layerId);
      let model;
      if (existingModel === undefined) {
        model = new CatalogGroup(layerId, this.catalogGroup.terria);
        try {
          // Sometimes WMS Layers have duplicate names
          // At the moment we ignore duplicate layers
          this.catalogGroup.terria.addModel(model, this.getLayerShareKeys(layer, layerId));
        } catch (e) {
          TerriaError.from(e, "Failed to add CatalogGroup").log();
          return;
        }
      } else {
        model = existingModel;
      }
      model.setTrait(CommonStrata.definition, "name", layer.Title);
      model.setTrait(CommonStrata.definition, "members", filterOutUndefined(members.map(member => this.getLayerId(member, layerId))));

      // Set group `info` trait if applicable
      if (layer && layer.Abstract && !containsAny(layer.Abstract, WebMapServiceCatalogItem.abstractsToIgnore)) {
        model.setTrait(CommonStrata.definition, "info", [createStratumInstance(InfoSectionTraits, {
          name: i18next.t("models.webMapServiceCatalogGroup.abstract"),
          content: layer.Abstract
        })]);
      }
      return;
    }

    // We can only request WMS layers if `Name` is defined
    if (!isDefined(layer.Name)) return;

    // No nested layers -> create model for WebMapServiceCatalogItem
    const existingModel = this.catalogGroup.terria.getModelById(WebMapServiceCatalogItem, layerId);
    let model;
    if (existingModel === undefined) {
      model = new WebMapServiceCatalogItem(layerId, this.catalogGroup.terria);
      try {
        // Sometimes WMS Layers have duplicate names
        // At the moment we ignore duplicate layers
        this.catalogGroup.terria.addModel(model, this.getLayerShareKeys(layer, layerId));
      } catch (e) {
        TerriaError.from(e, "Failed to add WebMapServiceCatalogItem").log();
        return;
      }
    } else {
      model = existingModel;
    }

    // Replace the stratum inherited from the parent group.
    model.strata.delete(CommonStrata.definition);
    model.setTrait(CommonStrata.definition, "name", layer.Title);
    model.setTrait(CommonStrata.definition, "url", this.catalogGroup.url);
    model._webMapServiceCatalogGroup = this.catalogGroup;
    model.setTrait(CommonStrata.definition, "getCapabilitiesUrl", this.catalogGroup.getCapabilitiesUrl);
    model.setTrait(CommonStrata.definition, "getCapabilitiesCacheDuration", this.catalogGroup.getCapabilitiesCacheDuration);
    model.setTrait(CommonStrata.definition, "layers", layer.Name);

    // if user defined following properties on the group level we should pass them to all group members
    model.setTrait(CommonStrata.definition, "hideSource", this.catalogGroup.hideSource);
    model.setTrait(CommonStrata.definition, "isOpenInWorkbench", this.catalogGroup.isOpenInWorkbench);
    model.setTrait(CommonStrata.definition, "isExperiencingIssues", this.catalogGroup.isExperiencingIssues);
    model.setTrait(CommonStrata.definition, "hideLegendInWorkbench", this.catalogGroup.hideLegendInWorkbench);

    // Copy over ExportWebCoverageTraits if `linkedWcsUrl` has been set
    // See WebMapServiceCatalogGroupTraits.perLayerLinkedWcs for more info
    if ((_this$catalogGroup$pe = this.catalogGroup.perLayerLinkedWcs) !== null && _this$catalogGroup$pe !== void 0 && _this$catalogGroup$pe.linkedWcsUrl) {
      updateModelFromJson(model, CommonStrata.definition, _objectSpread(_objectSpread({}, this.catalogGroup.traits.perLayerLinkedWcs.toJson(this.catalogGroup.perLayerLinkedWcs)), {}, {
        // Override linkedWcsCoverage with layer.Name
        linkedWcsCoverage: layer.Name
      })).logError("Failed to set `perLayerLinkedWcs` for WMS layer ".concat(layer.Title));
    }
    model.createGetCapabilitiesStratumFromParent(this.capabilities);
  }
  getLayerId(layer, parentLayerId) {
    var _layer$Name;
    if (!isDefined(this.catalogGroup.uniqueId) && !isDefined(parentLayerId)) {
      return;
    }
    return "".concat(parentLayerId !== null && parentLayerId !== void 0 ? parentLayerId : this.catalogGroup.uniqueId, "/").concat((_layer$Name = layer.Name) !== null && _layer$Name !== void 0 ? _layer$Name : layer.Title);
  }

  /** For backward-compatibility.
   * Previously we have used the following IDs
   * - `WMS Group Catalog ID/WMS Layer Name` - regardless of nesting
   * - `WMS Group Catalog ID/WMS Layer Title`
   */
  getLayerShareKeys(layer, layerId) {
    const shareKeys = [];
    if (layerId !== "".concat(this.catalogGroup.uniqueId, "/").concat(layer.Name)) shareKeys.push("".concat(this.catalogGroup.uniqueId, "/").concat(layer.Name));
    if (isDefined(layer.Name) && layer.Title !== layer.Name) shareKeys.push("".concat(this.catalogGroup.uniqueId, "/").concat(layer.Title));
    return shareKeys;
  }
}, _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMembersFromLayers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMembersFromLayers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMemberFromLayer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMemberFromLayer"), _class.prototype), _class);
/**
 * Creates an item in the catalog for each available WMS layer.
 * Note: To present a single layer in the catalog you can also use `WebMapServiceCatalogItem`.
 * @public
 * @example
 * {
 *   "type": "wms-group",
 *   "name": "Digital Earth Australia",
 *   "url": "https://ows.services.dea.ga.gov.au",
 * }
 */
export default class WebMapServiceCatalogGroup extends GetCapabilitiesMixin(UrlMixin(GroupMixin(CatalogMemberMixin(CreateModel(WebMapServiceCatalogGroupTraits))))) {
  get type() {
    return WebMapServiceCatalogGroup.type;
  }
  async forceLoadMetadata() {
    let getCapabilitiesStratum = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
    if (getCapabilitiesStratum === undefined) {
      getCapabilitiesStratum = await GetCapabilitiesStratum.load(this);
      runInAction(() => {
        this.strata.set(GetCapabilitiesMixin.getCapabilitiesStratumName, getCapabilitiesStratum);
      });
    }
  }
  async forceLoadMembers() {
    const getCapabilitiesStratum = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
    if (getCapabilitiesStratum !== undefined) {
      await runLater(() => getCapabilitiesStratum.createMembersFromLayers());
    }
  }
  get defaultGetCapabilitiesUrl() {
    if (this.uri) {
      return this.uri.clone().setSearch({
        service: "WMS",
        version: "1.3.0",
        request: "GetCapabilities"
      }).toString();
    } else {
      return undefined;
    }
  }
}
_defineProperty(WebMapServiceCatalogGroup, "type", "wms-group");